/* eslint-disable no-unused-vars */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { superAdminMenu, adminMenu, compMenu, financeMenu, atsMenu, hqMenu, pOpMenu } from './menus';

export const MENUS = {
  's-admin': superAdminMenu,
  'comp': compMenu,
  'finance': financeMenu,
  'ats': atsMenu,
  'hq-operator': hqMenu,
  'p-operator': pOpMenu,
  'admin': adminMenu,
};
// Menu helper function
export const getMenuForRole = (role) => {

  if (!MENUS[role]) {
    // console.error(`No menu found for role: ${role}`);
    return [];
  }

  const rolePrefix = `/${role}`; // Use the role as the route prefix

  const addPrefixToRoutes = (menuItems) => {
    return menuItems.map((item) => {
      const updatedItem = { ...item };

      // Update the NavLink routes for top-level items
      if (React.isValidElement(item.label) && item.label.type === NavLink) {
        updatedItem.label = React.cloneElement(item.label, {
          to: rolePrefix + item.label.props.to,
        });
      }

      // Recursively handle children items
      if (item.children) {
        updatedItem.children = addPrefixToRoutes(item.children);
      }

      return updatedItem;
    });
  };

  return addPrefixToRoutes(MENUS[role]);
};
